import {
	BaseError,
} from './BaseError';

export class GetSpecificationStatusError extends BaseError {
	constructor(message: string, stack?: string) {
		super(message, stack);
	}
}
